import React from "react";

function Image({ children }: { children: string }) {
  return (
    <picture className="w-full h-[400px] flex justify-center items-center">
      <img src={children} alt="" className="h-full object-cover" />
    </picture>
  );
}

export default Image;
